<template>
  <v-app>
    <template v-if="currentUser">
      <Header/>
      <router-view/>
      <Footer/>
    </template>
    <template v-else>
      <router-view/>
    </template>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/Layout/Header'
import Footer from '@/components/Layout/Footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  }
}
</script>
